<template>
    <div class="main-content">
        <!-- Start Hero Section -->
        <section class="hero-section" id="home">
            <div class="swiper-container main-slider">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="slide-inner bg-image w-100 ria-image no-scroll-bar" data-image-src="assets/images/ria/Hero.png">
                            <div class="slide-content text-white w-100">
                                <div class="slide-ria">
                                    <div class="ria-title">
                                        <div class="ria-logo">
                                            <img src="../assets/images/ria/RIA.svg" alt="" class="logo" />
                                            <img src="../assets/images/ria/qr-code.png" class="qr-code" />
                                        </div>
                                        <h2 class="ria-header">Rapid Innovation Acceleration</h2>
                                        <div class="ria-text desktop">
                                            <div>
                                                Empowering Innovation
                                            </div>
                                            <div>through Strategic</div>
                                            <div>Partnerships</div>
                                        </div>
                                        <div class="ria-text tablet">
                                            <div>
                                                Empowering Innovation through Strategic Partnerships
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ria-desc">
                                        <p>
                                            MoveAmerica is powering the rapid innovation in collaboration with the U.S. Department of Defense (DoD)
                                            Office of Small Business Programs through the Mentor-Protégé Program (MPP). The goal of this initiative is
                                            to strengthen our national defense supply chain by fostering innovation through partnerships with industry
                                            and academia.
                                        </p>
                                        <br />
                                        <p>
                                            Our main mission in this effort is to establish and execute MPP agreements across the Armed Services and
                                            Defense Agencies. The MPP connects small businesses that want to join or participate in the Defense
                                            Industrial Base (DIB) with larger companies that can provide the guidance needed to navigate the
                                            complicated government procurement process.
                                        </p>
                                        </br />
                                        <div class="ria-qr-container">
                                            <p>
                                                These strategic partnerships will allow smaller companies to develop and advance critical and emerging
                                                technology that will allow the U.S. military to reassert and maintain its technical dominance.
                                            </p>
                                            <img src="../assets/images/ria/qr-code.png" width="184" height="180" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--End Hero Section -->
        <!-- Start Community Area -->
        <section class="join-community section" id="joincommunity">
            <div class="section-title desktop">
                <div class="separator" />
                <div>
                    <div>Join our mentor community</div>
                    <div>Representing top prime contractors</div>
                </div>
            </div>
            <div class="section-title tablet">
                <div>Join our mentor community Representing top prime contractors</div>
            </div>
            <div class="section-logos">
                <img src="../assets/images/ria/logos/BP-Logo 2.svg" alt="" />
                <img src="../assets/images/ria/logos/Boeing_full_logo_(variant) 1.svg" alt="" />
                <img src="../assets/images/ria/logos/Raytheon-Emblem 1 (Traced).svg" alt="" />
                <img src="../assets/images/ria/logos/IBM_logo 1.svg" alt="" />
                <img src="../assets/images/ria/logos/Lockheed_Martin-Logo 1.svg" alt="" />
                <img src="../assets/images/ria/logos/L3Harris_Technologies-Logo 2.svg" alt="" />
                <span>+ more</span>
            </div>
        </section>
        <!-- End Community Area -->
        <!-- Start Mentor Area -->
        <section class="section mentor" id="mentor">
            <div class="container">
                <h3><span class="orange">Streamlined </span>Agreement Execution</h3>
                <p class="desc">
                    At the core of MoveAmerica’s effort is our commitment to streamline the execution of agreements, ensuring that partnerships
                    between businesses are not only strategic but also efficient. MoveAmerica simplifies the process through the following:
                </p>
                <div class="box-wrapper">
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/1985474 1 (Traced).svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Centralized Coordination</h4>
                            <p>
                                MoveAmerica will serve as a central point of coordination for all MPP-related activities, from initiation to
                                completion. This centralized approach reduces administrative overhead and speeds up the agreement process.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/person-chalkboard-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Expert Guidance</h4>
                            <p>
                                With a deep understanding of the DoD's unique requirements, MoveAmerica provides expert guidance on navigating the
                                complexities of MPP agreements. This includes overcoming challenges related to cybersecurity, foreign ownership
                                controls, and DoD procurement policies.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/box-open-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Advanced Tools and Resources</h4>
                            <p>
                                MoveAmerica, through the Rapid Innovation Accelerator hubs, will leverage state-of-the-art tools and resources to
                                facilitate agreement execution. This includes access to secure facilities and connectivity, which is essential for
                                meeting DoD contract requirements.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/people-group-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Enhanced Collaboration</h4>
                            <p>
                                Through networking events and educational programs, MoveAmerica fosters an environment of collaboration and synergy,
                                making it easier for businesses to find the right partners and execute agreements smoothly.
                            </p>
                        </div>
                    </div>
                    <div class="box support-services">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/Help Desk _.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Support Services</h4>
                            <p>
                                MoveAmerica offers tailored support services that will help businesses understand and meet the specific requirements
                                of MPP agreements, which significantly reduces delays and enhances compliance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <h3>
                    <span class="orange">Flexible </span>and
                    <span class="tablet">Adaptive Services</span>
                    <h3 class="desktop">Adaptive Services</h3>
                </h3>
                <p class="desc">
                    MoveAmerica provides a comprehensive suite of services under the direction of the DoD Office of Small Business Programs (OSBP) to
                    support small businesses in the following various critical areas:
                </p>
                <div class="box-wrapper">
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/laptop-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Enhanced Training and Education</h4>
                            <p>
                                Delivering both group and individualized training sessions tailored to the unique needs of small businesses in the
                                defense sector.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/unlock-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Secure Facilities and Connectivity Access</h4>
                            <p>
                                Offering access to secure facilities and connectivity required for compliance with DoD contracts, ensuring that small
                                businesses can meet stringent security demands.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/calendar-days-regular 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Engaging Outreach and Events</h4>
                            <p>
                                Organizing networking, matchmaking, and educational events that promote connectivity and synergy within the MPP
                                community.
                            </p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-icon">
                            <img src="../assets/images/ria/icons/shield-halved-solid 1.svg" alt="" />
                        </div>
                        <div class="box-content">
                            <h4>Expert Policy and Procedure Guidance</h4>
                            <p>
                                Providing guidance on navigating DoD industrial base challenges including Cybersecurity, Foreign Ownership Control or
                                Influence (FOCI), and DoD Procurement Policies.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="contact-us">
                    <h2>Contact Us</h2>
                    <p>
                        For more information about MoveAmerica and how it can support and bolster MPP companies and agreements, contact us at
                        <a href="mailto:info@moveamerica.org" class="email">info@moveamerica.org</a>.
                    </p>
                </div>
            </div>
        </section>
        <!-- End Mentor Area -->
        <section class="section learn-more" id="learnmore">
            <h2>Learn More <span>About the OSBP MPP Program</span></h2>
            <p>
                For those interested in diving deeper into the details and benefits of the MPP program, visit the official MPP Portal site. This
                resource offers comprehensive information and support for both new and existing participants in the MPP program, ensuring they have
                all the necessary tools and knowledge to succeed.
            </p>
        </section>
        <!-- Comment out this section for now, may need to bring back later: MOVEACOMM-74 -->
        <!-- <section class="section mppsummit" id="mppsummit">
            <div class="container">
                <div class="title">July 29 - Aug 1</div>
                <div class="subtitle">
                    <p>Network with current and potential Mentors and</p>
                    <p>Protégés at the annual Mentor-Protégé summit.</p>
                </div>
                <div class="summit-content">
                    <img src="../assets/images/ria/logos/Group 1000005412.svg" alt="" />
                </div>
                <div class="register">
                    <a
                        class="btn-golden"
                        href="https://web.cvent.com/event/0c4877d1-697c-48ca-aebd-01df112c2a0f/websitePage:fb32d815-6dc5-41b6-a2ea-246fc3371fc1"
                    >
                        Go to Registration
                        <span>
                            <img src="../assets/images/ria/Masked Icon.svg" alt="" />
                        </span>
                    </a>
                </div>
            </div>
        </section> -->
        <section class="section mpp-journey" id="mppjourney">
            <div class="desc mobile">Ready to take your company to the next level?</div>
            <div class="container">
                <img src="../assets/images/ria/logos/MPP logo FINAL[81] 1.svg" alt="" />
                <div class="content">
                    <div class="desc desktop">Ready to take your company to the next level?</div>
                    <a class="btn-golden" href="https://mpp.acq.osd.mil/mpp/#/">
                        start your mpp journey now
                        <span>
                            <img src="../assets/images/ria/Masked Icon.svg" alt="" />
                        </span>
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
//WOW JS
import { WOW } from "wowjs";

// import Swiper styles
import "../assets/css/swiper.min.css";
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
//ISOTOP JS
import "../assets/js/jquery.isotope.min.js";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

//MAGNIFIC POPUP JS
import "magnific-popup/dist/jquery.magnific-popup.min.js";
import "magnific-popup/dist/magnific-popup.css";
export default {
    name: "index",

    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.initBackgroundImage();
            this.initFooterHeight();
        },
        /*----BACKGROUND IMAGE-----*/
        initBackgroundImage() {
            $(".bg-image").css("background", function() {
                var bg = "url(" + $(this).data("image-src") + ") no-repeat center center";
                return bg;
            });
        },
        initFooterHeight() {
            var footerHeight = $("footer").outerHeight();
            $(".main-content").css("margin-bottom", footerHeight);
        },
    },
};
</script>
<style scoped>
.section {
    padding-top: 0;
    padding-bottom: 0;
}

.join-community {
    display: inline-flex;
    padding: 36px 106px 35.878px 120px;
    justify-content: space-between;
    align-items: flex-start;
    gap: 35px;
    background: linear-gradient(0deg, #03426d 0%, #03426d 100%), linear-gradient(2deg, #243d80 75.17%, rgba(36, 61, 128, 0) 97%);
    width: 100%;
}

.join-community .section-title.desktop {
    display: flex;
    align-items: center;
    gap: 23px;
    height: 48px;
}
.join-community .section-title.tablet {
    display: none;
}

.join-community .section-title div {
    color: var(--OSBP-White, #fff);
    font-feature-settings: "clig" off, "liga" off;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 24px */
    letter-spacing: 0.15px;
    text-transform: uppercase;
}

.join-community .separator {
    width: 6px;
    height: 46px;
    background: var(--MPP-Light-Blue, #96b7e0);
}

.join-community .section-logos {
    display: flex;
    align-items: center;
    gap: 23.231px;
    height: 48.12px;
}

.join-community .section-logos span {
    color: #fff;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Lato;
    font-size: 28.277px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 33.933px */
    letter-spacing: 0.141px;
    text-transform: uppercase;
}

.mentor {
    display: flex;
}

.mentor .container {
    width: 50%;
    height: 1808px;
    flex-shrink: 0;
    background: linear-gradient(99.59deg, #00375c -2.14%, #002945 100.3%);
    padding: 86px 100px 118px 118px;
    display: flex;
    flex-direction: column;
}

.mentor .container h3 {
    color: white;
    font-family: Lato;
    font-size: 40px;
    font-style: normal;
    font-weight: 900;
    line-height: 54px; /* 135% */
}

.mentor .container h3 .orange {
    color: #ff7c0f;
}

.mentor .container h3 .tablet {
    display: none;
}

.mentor .container .desc {
    color: var(--OSBP-White, #fff);
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; /* 133.333% */
    width: 470px;
    min-height: 250px;
    margin-top: 21px;
}

.mentor .container .box-wrapper {
    display: flex;
    flex-direction: column;
    gap: 29px;
    margin-top: 18px;
}

.mentor .container .box {
    display: flex;
    padding: 27px 20px 27px 0px;
    border-radius: 10px;
    background: #03426d;
}

.mentor .container .box .box-icon {
    text-align: center;
    flex-shrink: 0;
    width: 114px;
}

.mentor .container .box .box-icon img {
    margin-top: 15px;
    max-width: 100%;
    height: auto;
}

.mentor .container .box .box-content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    color: var(--OSBP-White, #fff);
    font-feature-settings: "clig" off, "liga" off;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 21.6px */
    letter-spacing: 0.15px;
}

.mentor .container .box .box-content h4 {
    font-size: 22px;
    font-weight: 600;
}

.mentor .contact-us {
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: white;
}

.mentor .contact-us h2 {
    font-family: Lato;
    font-size: 40px;
    font-style: normal;
    font-weight: 900;
    line-height: 54px; /* 135% */
}

.mentor .contact-us p {
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
}

.mentor .contact-us .email {
    text-decoration: underline !important;
    cursor: pointer;
    color:white;
}

.learn-more {
    background: white;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 46px 274px 45px 275px;
}

.learn-more h2 {
    color: #ff7c0f;
    text-align: center;
    font-family: Poppins;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 54px; /* 135% */
}

.learn-more h2 span {
    color: #00375c;
}

.learn-more p {
    color: #00375c;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; /* 133.333% */
    padding: 0 32px;
}

.mppsummit {
    background: url("../assets/images/ria/Hero Background 1.png");
    background-size: cover;
    padding-top: 68px;
    padding-bottom: 56px;
    text-align: center;
}

.mppsummit .title {
    color: #fff;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Rock Salt";
    font-size: 39.223px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.192px;
}

.mppsummit .subtitle {
    margin-top: 18px;
}

.mppsummit .subtitle p {
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; /* 133.333% */
}

.mppsummit .summit-content {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mppsummit .summit-content .separator {
    width: 102.183px;
    height: 0px;
    background: white;
}

.mppsummit .register {
    margin-top: 44px;
}

.mpp-journey {
    background: #00375c;
    text-align: center;
}

.mpp-journey .container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 140px;
}

.mpp-journey .container .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
}

.mpp-journey .container .content div, .mpp-journey .desc.mobile {
    color: var(--OSBP-White, #fff);
    font-family: Lato;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.3px;
}

.mpp-journey .desc.mobile {
    display: none;
}

.slide-ria .ria-title {
    margin-top: 56px;
}

p,
h2,
h3,
h4 {
    margin-bottom: 0;
}

@media only screen and (max-width: 1439px) {
    .slide-ria .ria-title {
        margin-top: 0px;
    }
    .join-community {
        padding: 34px 57px 8px 57px;
        flex-direction: column;
        gap: 23px;
    }
    .join-community .section-title.desktop {
        display: none;
    }
    .join-community .section-title.tablet {
        display: flex;
        align-items: center;
        text-align: center;
        padding: 0 80px;
    }
    .join-community .section-logos {
        height: 68px;
    }
    .join-community .section-title div {
        font-size: 20px;
    }
    .mentor {
        flex-direction: column;
        background: linear-gradient(99.59deg, #00375c -2.14%, #002945 100.3%);
    }
    .mentor .container {
        padding: 91px 32px 0 32px;
        width: 100%;
        max-width: 100%;
        height: unset;
        background: none;
    }
    .mentor .container .desc {
        width: 100%;
        min-height: unset;
        text-align: center;
    }
    .mentor .container h3 {
        text-align: center;
        display: flex;
        gap: 10px;
        justify-content: center;
        line-height: 120%;
    }
    .mentor .container h3 .tablet {
        display: block;
    }
    .mentor .container h3 .desktop {
        display: none;
    }
    .mentor .contact-us {
        padding-bottom: 40px;
        border-radius: 10px;
        background: #03426D;
        margin: 83px -32px 0 -32px;
        padding-left: 32px;
        padding-right: 32px;
    }
    .learn-more {
        padding: 40px 57px;
        gap: 18px;
    }
    .learn-more h2 {
        text-align: left;
        font-size: 25px;
        line-height: 25px;
    }
    .learn-more p {
        text-align: left;
        padding: 0;
        font-size: 16px;
        line-height: 16px;
    }
    .mpp-journey .container {
        gap: 15px;
    }
    .mpp-journey .container img {
        width: 74px;
    }
    .mpp-journey .container .content {
        gap: 15px;
    }
    .mpp-journey .container .content div {
        font-size: 16px;
    }
    .btn-golden {
        font-size: 12px;
        padding: 10px;
        gap: 8px;
    }
    .btn-golden span img {
        width: 24px !important;
    }
}

@media only screen and (max-width: 767px) {
    .join-community {
        padding: 36px 12px 0px 20px;
        flex-direction: column;
        gap: 23px;
    }
    .join-community .section-title.desktop {
        display: flex;
    }
    .join-community .section-title.tablet {
        display: none;
    }
    .join-community .section-title div {
        font-size: 16px;
    }
    .join-community .section-logos {
        height: 30px;
        gap: 4px;
    }
    .join-community .section-logos img {
        max-height: 30px;
        flex-shrink: 0;
    }
    .join-community .section-logos span {
        font-size: 16px;
    }
    .mentor {
        flex-direction: column;
        gap: 40px;
    }
    .mentor .container {
        padding: 46px 20px 0 20px;
        width: 100%;
        max-width: 100%;
        height: unset;
        background: none;
    }
    .mentor .container .desc {
        width: 100%;
        min-height: unset;
        text-align: left;
        font-size: 16px;
        line-height: 20px;
        padding: 0 13px;
    }
    .mentor .container h3 {
        text-align: left;
        display: block;
        font-size: 25px;
        padding: 0 13px;
    }
    .mentor .container h3 .tablet {
        display: block;
    }
    .mentor .container h3 .desktop {
        display: none;
    }
    .mentor .container .box-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    .mentor .container .box {
        flex-direction: column;
        padding: 0;
    }
    .mentor .container .box .box-icon img {
        max-height: 50px;
    }
    .mentor .container .box .box-content {
        padding: 4px 9px 27px 9px;
    }
    .mentor .container .box .box-content h4 {
        font-size: 18px;
    }
    .mentor .container .box .box-content p {
        font-size: 12px;
    }
    .box.support-services {
        grid-column: span 2;
    }
    .box.support-services img {
        max-height: unset;
    }
    .mentor .contact-us {
        margin: 83px -20px 0 -20px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .mentor .contact-us h2 {
        font-size: 25px;
    }
    .mentor .contact-us p {
        font-size: 16px;
        line-height: 20px;
    }
    .learn-more {
        padding: 29px 49px 29px 28px;
        gap: 5px;
    }
    .learn-more h2 {
        text-align: left;
        font-size: 20px;
        line-height: 20px;
    }
    .learn-more p {
        text-align: left;
        padding: 0;
        font-size: 16px;
        line-height: 16px;
    }
    .mppsummit .title {
        font-size: 25px;
    }
    .mppsummit .container .summit-content img {
        width: 100%;
    }
    .mppsummit .subtitle p {
        font-size: 20px;
        line-height: 30px;
        font-weight: 900;
    }
    .mpp-journey .container {
        gap: 15px;
    }
    .mpp-journey .container img {
        width: 74px;
    }
    .mpp-journey .container .content {
        gap: 15px;
    }
    .mpp-journey .container .content div {
        font-size: 16px;
    }
    .mpp-journey .container .desc.desktop {
        display: none;
    }
    .mpp-journey .desc.mobile {
        display: block;
        font-size: 16px;
    }
    .mpp-journey .container .content .btn-golden {
        letter-spacing: unset;
    }
    .btn-golden span img {
        width: 24px !important;
    }
}

.swiper-container {
    overflow-y: auto;
}
.ria-image {
    overflow-y: auto;
}
.main-slider .swiper-slide .slide-inner:after {
    background: none;
}

</style>
